import { RootState } from 'app/store/rootReducer';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import { APP_VER } from '../config';

export interface ErrorMessageProps {
  errorMessage: string;
}

export default function ErrorMessage(props: ErrorMessageProps) {
  const { errorMessage } = props;

  const { user } = useSelector((state: RootState) => state.auth);

  return (
    <Box mx={2}>
      <h1>Sorry... there was an error</h1>
      <pre>User ID: {user?.id}</pre>
      <pre>App Version: {APP_VER}</pre>
      <pre>URL: {window.location.href}</pre>
      <pre>Timestamp: {new Date().toUTCString()}</pre>
      <pre>Browser: {navigator.userAgent}</pre>
      <pre>{errorMessage}</pre>
    </Box>
  );
}
